// src/components/Partners.jsx
import "../styles/partners.css";

const req = require.context(
  "../assets/img/partner",
  false,
  /\.(webp|png|jpg)$/
);
const partners = req.keys().map((file, index) => ({
  id: index + 1,
  src: req(file),
  alt: `partner-${index + 1}`,
}));

const Partners = () => {
  return (
    <div className="partners-bg">
      <div className="partners">
        <div className="partners__wrapper">
          <h2 className="partners__title">
            Các đối tác khách hàng
            <span className="line"></span>
          </h2>
        </div>

        <div className="partners__list">
          {partners.map((partner) => (
            <div
              key={partner.id}
              className="partners__item"
            >
              <div className="partner-content">
                <img
                  src={partner.src}
                  alt={partner.alt}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Partners;
